import type { CssSizeUnit, ThemeName, } from "../../../types";
import styled from "styled-components";


export const Box = styled.div<{$theme?: ThemeName; $padding?: CssSizeUnit; $position?: "absolute" | "relative" | "fixed" | "sticky" | "static"; $debug?: boolean; $gap?: CssSizeUnit; }>`
	display: flex;
	flex-direction: column;
	padding: ${({ $padding }) => $padding || "1rem"};
	${({ $position }) => $position && `position: ${$position};`}
	${({ $debug }) => $debug && `border: 1px solid red;`}
	${({ $gap }) => $gap && `gap: ${$gap};`}
`;
